import { Alert } from '@festina-life/ui/feedback'
import { paperStyles } from '@festina-life/ui/libs'
import { Stack } from '@festina-life/ui/structure'
import cx from 'classnames'

import type { ParameterValueEntityOperation } from '../../uiModels/parameterOperations/types'
import type { OperationWithSourceInfo } from '../../uiModels/types'
import { sortValueOperationsByToDateDescending } from './helpers'
import { ParameterValueOperation } from './ParameterValueOperation'

type Props = {
  title: string
  tip: string
  operations: OperationWithSourceInfo<ParameterValueEntityOperation>[]
  className?: string
}

/** One titled group of a parameter's operations in the parameter viewer sidebar. */
export const ParameterValueOperationsSection = ({
  title,
  tip,
  operations,
  className,
}: Props) => (
  <section
    aria-label={title}
    className={cx('flex min-h-0 flex-col overflow-hidden', className)}
  >
    <Stack
      padding="normal"
      className={cx(
        'shrink-0 items-center',
        paperStyles({ isFaded: true, borders: ['bottom'] }),
      )}
    >
      {title}
      <Alert variant="mini" severity="info">
        {tip}
      </Alert>
    </Stack>
    <Stack
      as="ul"
      className="min-h-0 flex-col overflow-y-auto"
      padding="normal"
    >
      {sortValueOperationsByToDateDescending(operations).map((operation) => (
        <ParameterValueOperation
          key={operation.internalOperation.operationKey}
          operation={operation}
        />
      ))}
    </Stack>
  </section>
)
